<template>
  <span>
    <!-- Las minas activas -->
    <DaiCapaGeojson
      id="minas_activas_legales"
      :url="publicPath+'data/capasv2/09_minas_operacion_activa_estatus_minas-legales.geojson'"
      titulo="Autorizadas"
      :estilo-capa="{ fill:{color:'#D35BAE'}, stroke: { width: 1,color:'#D35BAE' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_activas_legales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="minas_activas_ilegales"
      :url="publicPath+'data/capasv2/09_minas_operacion_activa_estatus_minas-ilegales.geojson'"
      titulo="No autorizadas"
      :estilo-capa="{ fill:{color:'#DB9EC2'}, stroke: { width: 1,color:'#DB9EC2' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_activas_ilegales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="minas_activas_sininfo"
      :url="publicPath+'data/capasv2/09_minas_operacion_activa_estatus_sin-informacion-suficiente.geojson'"
      titulo="Sin información"
      :estilo-capa="{ fill:{color:'#F2D4F1'}, stroke: { width: 1,color:'#F2D4F1' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_activas_sininfo"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />

    <!-- Las minas inactivas -->
    <DaiCapaGeojson
      id="minas_inactivas_legales"
      :url="publicPath+'data/capasv2/09_minas_operacion_inactiva_estatus_minas-legales.geojson'"
      titulo="Autorizadas"
      :estilo-capa="{ fill:{color:'#655D8A'}, stroke: { width: 1, color:'#655D8A' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_inactivas_legales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="minas_inactivas_ilegales"
      :url="publicPath+'data/capasv2/09_minas_operacion_inactiva_estatus_minas-ilegales.geojson'"
      titulo="No autorizadas"
      :estilo-capa="{ fill:{color:'#9C93BF'}, stroke: { width: 1, color:'#9C93BF' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_inactivas_ilegales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="minas_inactivas_sininfo"
      :url="publicPath+'data/capasv2/09_minas_operacion_inactiva_estatus_sin-informacion-suficiente.geojson'"
      titulo="Sin información"
      :estilo-capa="{ fill:{color:'#D8CCFF'}, stroke: { width: 1, color:'#D8CCFF' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_inactivas_sininfo"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <!-- Las capas temporales-->
    <DaiCapaGeojson
      id="minas_temporales_legales"
      :url="publicPath+'data/capasv2/09_minas_operacion_temporal_estatus_minas-legales.geojson'"
      titulo="Autorizadas"
      :estilo-capa="{ fill:{color:'#43ADBE'}, stroke: { width: 1, color:'#43ADBE' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_temporales_legales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="minas_temporales_ilegales"
      :url="publicPath+'data/capasv2/09_minas_operacion_temporal_estatus_minas-ilegales.geojson'"
      titulo="No autorizadas"
      :estilo-capa="{ fill:{color:'#8EB5BE'}, stroke: { width: 1, color:'#8EB5BE' } }"
      
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.minas_temporales_ilegales"
      :contenidoTooltip="tooltipMinas"
      :use-loader="true"
    />
    
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      visibles: {
        minas_activas_legales: false,
        minas_activas_ilegales: false,
        minas_activas_sininfo: false,
        minas_inactivas_legales: false,
        minas_inactivas_ilegales: false,
        minas_inactivas_sininfo: false,
        minas_temporales_legales: false,
        minas_temporales_ilegales: false,
      },
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.mineria;
    },
  },
  watch: {
    esteTemaActivo(nv) {
        this.visibles.minas_activas_legales = nv;
        this.visibles.minas_activas_ilegales = nv;
        this.visibles.minas_activas_sininfo = nv;
        this.visibles.minas_inactivas_legales = nv;
        this.visibles.minas_inactivas_ilegales = nv;
        this.visibles.minas_inactivas_sininfo = nv;
        this.visibles.minas_temporales_legales = nv;
        this.visibles.minas_temporales_ilegales = nv;
    },
  },
  methods:{
    tooltipMinas(f){
      return `Estado: <b>${f.nom_ent}</b><br>
             Municipio: <b>${f.nom_mun}</b><br>
             Nombre: <b>${
                f.nom_prop
              }</b><br>Estatus: <b>${f.estatus}</b><br>Operacion: <b>${
                f.operacion
              }</b><br>Material: <b>${f.material}</b><br> UGA: <b>${
                f.pol_est
              }</b><br>Hectáreas: <b>${Math.round(f.sup_ha).toLocaleString(
                'en'
              )}</b>`
    
    }
  },
  beforeMount(){
    let nv = this.esteTemaActivo;
    this.visibles.minas_activas_legales = nv;
    this.visibles.minas_activas_ilegales = nv;
    this.visibles.minas_activas_sininfo = nv;
    this.visibles.minas_inactivas_legales = nv;
    this.visibles.minas_inactivas_ilegales = nv;
    this.visibles.minas_inactivas_sininfo = nv;
    this.visibles.minas_temporales_legales = nv;
    this.visibles.minas_temporales_ilegales = nv;
  }
};
</script>